import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import SkeletonField from './SkeletonField'

export type SkeletonSectionProps = {
    fields?: number
    fieldSpan?: 3 | 4 | 6 | 12
    showHeader?: boolean
    showActions?: boolean
    footerActions?: boolean
    fill?: boolean | number | string
    children?: React.ReactNode
}

const SPAN_RHYTHM = [12, 6, 6, 4, 4, 4, 3, 3, 3, 3] as const

const fillHeight = (fill: boolean | number | string) => {
    if (fill === false) return undefined
    if (fill === true) return '70vh'
    return fill
}

export default function SkeletonSection(props: Readonly<SkeletonSectionProps>) {
    const {
        fields = 10,
        fieldSpan,
        showHeader = true,
        showActions = false,
        footerActions = false,
        fill = true,
        children,
    } = props

    const spanAt = (index: number) => fieldSpan ?? SPAN_RHYTHM[index % SPAN_RHYTHM.length]

    return (
        <Grid container spacing={2} size={12}>
            {showHeader && (
                <Grid size={12}>
                    <Paper sx={{ p: 2 }}>
                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{ alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Skeleton variant="text" width={220} sx={{ fontSize: '1.5rem' }} />
                            {showActions && <Skeleton variant="rounded" width={120} height={36} />}
                        </Stack>
                    </Paper>
                </Grid>
            )}

            <Grid size={12}>
                <Paper
                    sx={{
                        p: 2,
                        minHeight: fillHeight(fill),
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Grid container spacing={4} rowSpacing={4}>
                        {children ??
                            Array.from({ length: fields }, (_, index) => (
                                <Grid key={index} size={{ xs: 12, md: spanAt(index) }}>
                                    <SkeletonField />
                                </Grid>
                            ))}
                    </Grid>

                    {footerActions && (
                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{ mt: 'auto', pt: 4, justifyContent: 'center' }}
                        >
                            <Skeleton variant="rounded" width={260} height={40} />
                            <Skeleton variant="rounded" width={260} height={40} />
                        </Stack>
                    )}
                </Paper>
            </Grid>
        </Grid>
    )
}
